import { render } from "./CuponesPage.vue?vue&type=template&id=2e4df61e"
import script from "./CuponesPage.vue?vue&type=script&lang=js"
export * from "./CuponesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__